export enum DeviceLogs {
  OSDownloadSuccess = "OSDownloadSuccess",
  OSDownloadFailed = "OSDownloadFailed",

  OSUpdateTriggered = "OSUpdateTriggered",
  OSUpdateSuccess = "OSUpdateSuccess",
  OSUpdateFailed = "OSUpdateFailed",

  AppDownloadSuccess = "AppDownloadSuccess",
  AppDownloadFailed = "AppDownloadFailed",

  AppUpdateTriggered = "AppUpdateTriggered",
  AppUpdateSuccess = "AppUpdateSuccess",
  AppUpdateFailed = "AppUpdateFailed",

  RebootTriggered = "RebootTriggered",
  AutoShutdown = "AutoShutdown",
  RebootStarted = "RebootStarted",
  BootCompleted = "BootCompleted",

  ManagementConfigUpdateTriggered = "ManagementConfigUpdateTriggered",
  ManagementConfigResetTriggered = "ManagementConfigResetTriggered",
  BrightnessChanged = "BrightnessChanged",
  BrightnessChangeError = "BrightnessChangeError",
  VolumeChanged = "VolumeChanged",
  TimeoutsChanged = "TimeoutsChanged",
  SystemSettingsChanged = "SystemSettingsChanged",
  UnkownManagementConfigType = "UnkownManagementConfigType",

  HomeLauncherChanged = "HomeLauncherChanged",
  WifiSettingsChanged = "WifiSettingsChanged",
  DownloadSkipped = "DownloadSkipped",
  DownloadTriggered = "DownloadTriggered",
  IpdSet = "IpdSet",
  PermissionsChanged = "PermissionsChanged",

  ManagementConfigApplied = "ManagementConfigApplied",
  ManagementConfigApplyFailed = "ManagementConfigApplyFailed",

  WifiRequestIgnored = "WifiRequestIgnored",
  WifiRequestFailed = "WifiRequestFailed",
}

export function deviceLogMessageFormatter(message: string) {
  return message.replace(/([A-Z])/g, " $1").trim();
}
